import { render, staticRenderFns } from "./ListChanges.vue?vue&type=template&id=99cdeef0&scoped=true&"
import script from "./ListChanges.vue?vue&type=script&lang=ts&"
export * from "./ListChanges.vue?vue&type=script&lang=ts&"
import style0 from "./ListChanges.vue?vue&type=style&index=0&id=99cdeef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cdeef0",
  null
  
)

export default component.exports